<template>
  <div class="footer" id="foot2" >
    <div class="content" v-if="config">{{config.copyright}}     {{config.gxbba}}   {{config.ggwba}}</div>
  </div>
</template>

<script>
import { getconfig } from "@/api/index.js"
export default {
  name: "Footer",
  data(){
    return {
     config:{
      copyright:'',gxbba:'',ggwba:''
     }
    }
  },
  mounted(){
    if(this.config==undefined||this.config==null){
         getconfig().then(res=>{
          if(res.code==1){
            this.config=res.data;
          }
        })
    }else{
      this.config=JSON.parse(localStorage.getItem("config"))
    }
  }
};
</script>

<style lang="less">
.footer {
  
  height:60px;line-height: 60px;
  background-color: #002855;
  text-align: center;
  .content {
    font-size: 15px;
    color: white;
  }
}
</style>
